import { styled, Typography } from "@mui/material";

export const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.light,
  fontWeight: 700,
  fontSize: "1.5rem",
  paddingBottom: "20px",
}));

export const SectionSubTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.light,
  fontWeight: 700,
  fontSize: "1.1rem",
  paddingBottom: "5px",
}));
